import { shareColumnsExtend, shareFormColumnsExtend } from './share';
export const RED_PACKET_TYPES = [
]

const entityColumns = {
  id: {
    model_name: 'RedPacket',
    column_type: 'id',
  },
  created_at: {
    model_name: 'RedPacket',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'RedPacket',
    column_type: 'datetime',
  },
  code: {
    model_name: 'RedPacket',
    column_type: 'string',
  },
  type: {
    model_name: 'RedPacket',
    column_type: 'type',
    extra: {
      options: [],
    },
  },
  total_amount: {
    model_name: 'RedPacket',
    column_type: 'decimal',
  },
  quantity: {
    model_name: 'RedPacket',
    column_type: 'integer',
  },
  state: {
    model_name: 'RedPacket',
    column_type: 'enum',
  },
  expired_at: {
    model_name: 'RedPacket',
    column_type: 'datetime',
  },
  kind: {
    model_name: 'RedPacket',
    column_type: 'enum',
  },
  limit_one_person_total_receive_count: {
    model_name: 'RedPacket',
    column_type: 'integer',
  },
  limit_one_person_receive_count_per_day: {
    model_name: 'RedPacket',
    column_type: 'integer',
  },
  remaining_amount: {
    model_name: 'RedPacket',
    column_type: 'string',
  },
  qrcode: {
    model_name: 'RedPacket',
    column_type: 'attached',
    extra: {
      size: 5,
    },
  },
  qrcode_with_audio: {
    model_name: 'RedPacket',
    column_type: 'attached',
    extra: {
      accept: 'audio/mp3, audio/aac',
      type: 'audio',
      size: 5,
    },
  },
  brand: {
    model_name: 'RedPacket',
    column_type: 'belongs_to',
    extra: {
      association_name: 'brand',
      model_name: 'Brand',
      foreign_key: 'brand_id',
    },
  },
  brand_id: {
    model_name: 'RedPacket',
    column_type: 'belongs_to',
    extra: {
      association_name: 'brand',
      model_name: 'Brand',
      foreign_key: 'brand_id',
    },
  },
  received_count: {
    model_name: 'RedPacket',
    column_type: 'string',
  },
  received_amount: {
    model_name: 'RedPacket',
    column_type: 'string',
  },
  user: {
    model_name: 'RedPacket',
    column_type: 'string',
  },
  custom_list_item_attributes: {
    model_name: 'RedPacket',
    column_type: 'string',
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(entityColumns, columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(entityColumns, columns, { formColumnsConfig, type, data })
}
